import React from 'react';
import { Link } from 'react-router-dom';
import './PrivacyPolicy.css';

const PrivacyPolicy = ({ t }) => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <div className="legal-header">
          <Link to="/" className="back-link">← {t.privacy.backToHome}</Link>
          <h1>{t.privacy.title}</h1>
          <p className="legal-last-updated">{t.privacy.lastUpdated}</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>{t.privacy.introduction.title}</h2>
            <p>{t.privacy.introduction.content}</p>
          </section>

          <section className="legal-section">
            <h2>{t.privacy.informationCollection.title}</h2>
            <p>{t.privacy.informationCollection.intro}</p>
            <ul>
              {t.privacy.informationCollection.items.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t.privacy.useOfInformation.title}</h2>
            <p>{t.privacy.useOfInformation.intro}</p>
            <ul>
              {t.privacy.useOfInformation.items.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t.privacy.dataSecurity.title}</h2>
            <p>{t.privacy.dataSecurity.content}</p>
          </section>

          <section className="legal-section">
            <h2>{t.privacy.cookies.title}</h2>
            <p>{t.privacy.cookies.content}</p>
          </section>

          <section className="legal-section">
            <h2>{t.privacy.userRights.title}</h2>
            <p>{t.privacy.userRights.intro}</p>
            <ul>
              {t.privacy.userRights.items.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t.privacy.changesToPolicy.title}</h2>
            <p>{t.privacy.changesToPolicy.content}</p>
          </section>

          <section className="legal-section">
            <h2>{t.privacy.contactInformation.title}</h2>
            <p>{t.privacy.contactInformation.content}</p>
            <div className="legal-contact-details">
              <p><strong>{t.privacy.contactInformation.email}:</strong> info@armarayan.com</p>
              <p><strong>{t.privacy.contactInformation.address}:</strong> {t.contact.addressValue}</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;

